<div class="simple-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="dialog-title">
      <mat-icon>description</mat-icon>
      <h2>{{ (data.isEditingNew ? 'ppwr.tdProfiles.dialog.addTitle' : 'ppwr.tdProfiles.dialog.editTitle') | transloco }}</h2>
    </div>

    <button mat-icon-button type="button" [attr.aria-label]="'common.buttons.close' | transloco" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-description">{{ 'ppwr.tdProfiles.dialog.description' | transloco }}</p>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.tdProfiles.dialog.nameLabel' | transloco }}</mat-label>
      <input matInput [formControl]="nameControl" />
      <mat-error *ngIf="nameControl.hasError('required')">{{ 'ppwr.tdProfiles.dialog.nameRequired' | transloco }}</mat-error>
      <mat-error *ngIf="nameControl.hasError('duplicateName')">{{ 'ppwr.tdProfiles.dialog.nameDuplicate' | transloco }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.evidenceFilterLabel' | transloco }}</mat-label>
      <mat-select multiple [value]="excludedEvidenceTypeIds" (selectionChange)="onEvidenceTypesChange($event.value)">
        <mat-option *ngFor="let evidenceType of data.evidenceTypes" [value]="evidenceType.id">{{ evidenceType.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data.configKey === 'system'" appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.tdProfiles.dialog.childPackagingUnitLabel' | transloco }}</mat-label>
      <mat-select [value]="getReferenceId('childPackagingUnitProfileId')" (selectionChange)="setReferenceId('childPackagingUnitProfileId', $event.value)">
        <mat-option [value]="noProfileId">{{ 'ppwr.tdProfiles.dialog.noneOption' | transloco }}</mat-option>
        <mat-option *ngFor="let profile of data.unitProfiles" [value]="profile.id">{{ profile.profileName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-icon *ngIf="data.configKey === 'system'" class="profile-info-icon" [matTooltip]="'ppwr.tdProfiles.dialog.noProfileInfo' | transloco"> info_outline </mat-icon>

    <mat-form-field *ngIf="data.configKey === 'unit'" appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.tdProfiles.dialog.childPackagingComponentProfileLabel' | transloco }}</mat-label>
      <mat-select [value]="getReferenceId('packagingComponentProfileId')" (selectionChange)="setReferenceId('packagingComponentProfileId', $event.value)">
        <mat-option [value]="noProfileId">{{ 'ppwr.tdProfiles.dialog.noneOption' | transloco }}</mat-option>
        <mat-option *ngFor="let profile of data.componentProfiles" [value]="profile.id">{{ profile.profileName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-icon *ngIf="data.configKey === 'unit'" class="profile-info-icon" [matTooltip]="'ppwr.tdProfiles.dialog.noProfileInfo' | transloco"> info_outline </mat-icon>

    <mat-form-field *ngIf="data.configKey === 'unit' || data.configKey === 'component'" appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.tdProfiles.dialog.multiMaterialProfileLabel' | transloco }}</mat-label>
      <mat-select [value]="getReferenceId('multiMaterialProfileId')" (selectionChange)="setReferenceId('multiMaterialProfileId', $event.value)">
        <mat-option [value]="noProfileId">{{ 'ppwr.tdProfiles.dialog.noneOption' | transloco }}</mat-option>
        <mat-option *ngFor="let profile of data.multiMaterialProfiles" [value]="profile.id">{{ profile.profileName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-icon *ngIf="data.configKey === 'unit' || data.configKey === 'component'" class="profile-info-icon" [matTooltip]="'ppwr.tdProfiles.dialog.noProfileInfo' | transloco">
      info_outline
    </mat-icon>

    <mat-button-toggle-group hideSingleSelectionIndicator class="view-toggle selection-mode-toggle" [value]="getSelectionMode()" (change)="applySelectionMode($event.value)">
      <mat-button-toggle class="folder-button view-toggle-button" value="all">
        {{ 'common.buttons.selectAll' | transloco }}
      </mat-button-toggle>
      <mat-button-toggle class="folder-button view-toggle-button" value="none">
        {{ 'common.buttons.selectNone' | transloco }}
      </mat-button-toggle>
      <mat-button-toggle class="folder-button view-toggle-button" value="minimum">
        {{ 'ppwr.tdProfiles.dialog.selectMinimumRequirements' | transloco }}
        <span class="minimum-requirement-dot"></span>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="field-tree-content field-tab-content">
      <app-profile-field-tree [node]="treeNode" [hideEvidenceFilter]="true" [customFieldOptions]="data.availableCustomFields" [minimumRequirementKeys]="data.minimumRequirements">
      </app-profile-field-tree>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="closeDialog()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="save()">
      {{ 'common.buttons.save' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
